"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// CORE
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const react_1 = require("@emotion/react");
const classnames_1 = __importDefault(require("classnames"));
// App-Components
const accounts_1 = require("companion-app-components/flux/accounts");
const categories_1 = require("companion-app-components/flux/categories");
// MUI
const Box_1 = __importDefault(require("@mui/material/Box"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const FilterList_1 = __importDefault(require("@mui/icons-material/FilterList"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const ExpandMoreRounded_1 = __importDefault(require("@mui/icons-material/ExpandMoreRounded"));
// DATA/UTILS
const utils_1 = require("components/QFilterSelect/utils");
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const compose_1 = __importDefault(require("utils/compose"));
// COMPONENTS
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const QButton_1 = __importDefault(require("components/QButton"));
const QFilterSelect_1 = __importDefault(require("components/QFilterSelect"));
const QDateRangePicker_1 = __importDefault(require("components/QDateRangePicker"));
const download_svg_1 = __importDefault(require("assets/download.svg"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
// LOCAL
const utils_2 = require("../utils");
const state_1 = require("../state");
const ReportsMenu_1 = __importDefault(require("./ReportsMenu"));
const chartSettings_styles_1 = __importDefault(require("./chartSettings.styles"));
const IncomeExpenseReportToggle_1 = __importDefault(require("./IncomeExpenseReportToggle"));
const ChartSettings = ({ handleDownload, showDownloadButton, classes, resetTransactionRegister, showViewFilter, viewOptions, viewValue, onViewChange, breakdownOptions: breakdownOptionsProp, breakdownValue, onBreakdownChange, }) => {
    var _a;
    const { state, dispatch } = React.useContext(state_1.ReportsStateContext);
    const { filterObject, dateRange, fallbackSelect, breakdownIncomeVsExpense, timeStep: timeStepState } = state;
    const [intervalIncVsExp, setIntervalIncVsExp] = React.useState(utils_2.IntervalFilterOptions[0].value);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const savingsAccountsById = (0, react_redux_1.useSelector)(accounts_1.accountsSelectors.getSavingAccounts);
    const isCategoriesLoading = (0, react_redux_1.useSelector)(categories_1.categoriesSelectors.getIsLoading);
    // pull paramaters out of the url
    const params = (0, react_router_dom_1.useParams)();
    const tabName = (params === null || params === void 0 ? void 0 : params.tabName) || 'spending';
    const groupByString = ((_a = params === null || params === void 0 ? void 0 : params.groupBy) === null || _a === void 0 ? void 0 : _a.replace('by-', '')) || (0, utils_2.getDefaultGroupByFromTabName)(tabName);
    const layoutView = params === null || params === void 0 ? void 0 : params.layoutView; // string representation of isOverTime
    const isTabIncomeVsExpense = tabName === utils_2.Tabs.INCOME_VS_SPENDING;
    const breakdownOtherThanNone = breakdownIncomeVsExpense.id !== utils_2.IncomeVsExpenseBreakdownTypes[0].id;
    const [filterAnchor, setFilterAnchor] = React.useState(null);
    const [customDateRangeAnchor, setCustomDateRangeAnchor] = React.useState(null);
    const { setDatasetPreference } = (0, useQPreferences_1.default)();
    React.useEffect(() => {
        if (isTabIncomeVsExpense && utils_2.IntervalFilterOptions.length === 2) {
            utils_2.IntervalFilterOptions.unshift({ label: 'None', value: 'none', id: 'none' });
            utils_2.IntervalFilterOptions.push({ label: 'Yearly', value: 'years', id: 'yearly' });
        }
        return (() => {
            if (utils_2.IntervalFilterOptions.length > 2) {
                utils_2.IntervalFilterOptions.shift();
                utils_2.IntervalFilterOptions.pop();
            }
        });
    }, [isTabIncomeVsExpense]);
    const groupByOptions = React.useMemo(() => (0, utils_2.getFilterOptionsFromTabName)(tabName), [tabName]);
    const groupBy = (groupByOptions === null || groupByOptions === void 0 ? void 0 : groupByOptions.find((x) => x.value === groupByString)) || (groupByOptions === null || groupByOptions === void 0 ? void 0 : groupByOptions[3]);
    const filterOnlySavingsAccounts = React.useCallback((acc) => savingsAccountsById.has(acc.id), [savingsAccountsById]);
    const toggleShowFilterSelect = React.useCallback((event) => {
        setFilterAnchor(filterAnchor ? undefined : event.currentTarget);
    }, [filterAnchor]);
    const saveFilterDetailsToPreference = (filtersApplied) => {
        setDatasetPreference({ reportsViewStates: { filterObject: filtersApplied } });
    };
    const handleApplyFilter = React.useCallback((newFilterObject) => {
        setFilterAnchor(null);
        dispatch({
            type: 'update',
            payload: {
                filterObject: ((0, utils_1.countFilterItems)(newFilterObject) + newFilterObject.get('payees').size) > 0 ? newFilterObject : null,
                hasAppliedFilters: true,
            },
        });
        saveFilterDetailsToPreference(newFilterObject);
    }, [setFilterAnchor, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps
    const handleGroupBySelect = React.useCallback((option) => {
        navigate(`/reports/${tabName}/by-${option.value}${layoutView ? `/${layoutView}` : ''}`);
    }, [navigate, tabName, layoutView]);
    const handleCloseCustomDateRange = React.useCallback(() => {
        setCustomDateRangeAnchor(null);
    }, []);
    const handleIncomeVsExpenseBreakdownSelect = React.useCallback((option) => {
        fallbackSelect.current = null;
        dispatch({
            type: 'update',
            payload: {
                breakdownIncomeVsExpense: option,
                selectedGraphCategory: '',
                selectedReportTableCell: '',
                visibleSectionIncomeVsExpense: '',
                timeStep: 'months',
                clearGraphSelection: true,
            },
        });
        resetTransactionRegister();
    }, [dispatch, fallbackSelect, resetTransactionRegister]);
    const handleIncomeVsExpenseIntervalSelect = React.useCallback((option) => {
        fallbackSelect.current = null;
        dispatch({
            type: 'update',
            payload: { timeStep: option.value, selectedGraphCategory: '', selectedReportTableCell: '', clearGraphSelection: true },
        });
        setIntervalIncVsExp(option.value);
    }, [dispatch, fallbackSelect]);
    const handleDateRangeSelect = React.useCallback((option) => {
        fallbackSelect.current = null;
        setCustomDateRangeAnchor(null);
        let baseTimeStep = 'months';
        if (!isTabIncomeVsExpense && option.value.count('days') <= 33) {
            baseTimeStep = 'days';
        }
        let resolvedTimeStep = baseTimeStep;
        if (intervalIncVsExp === utils_2.IntervalFilterOptions[1].value) {
            resolvedTimeStep = intervalIncVsExp;
        }
        if (isTabIncomeVsExpense) {
            resolvedTimeStep = timeStepState;
        }
        dispatch({
            type: 'update',
            payload: {
                dateRange: option,
                timeStep: resolvedTimeStep,
                selectedGraphCategory: '',
                selectedReportTableCell: '',
            },
        });
    }, [dispatch, fallbackSelect, intervalIncVsExp, timeStepState, isTabIncomeVsExpense]);
    const handleCustomDateRangeSelect = React.useCallback((interval) => {
        fallbackSelect.current = null;
        setCustomDateRangeAnchor(null);
        const isShortRange = interval.count('days') <= 33;
        let timeStep;
        if (isTabIncomeVsExpense) {
            timeStep = timeStepState;
        }
        else if (intervalIncVsExp === utils_2.IntervalFilterOptions[1].value) {
            timeStep = intervalIncVsExp;
        }
        else if (isShortRange) {
            timeStep = 'days';
        }
        else {
            timeStep = 'months';
        }
        const rangeOption = {
            label: 'Custom',
            value: interval,
            custom: true,
            noOfMonths: interval.count('months'),
        };
        dispatch({
            type: 'update',
            payload: {
                dateRange: rangeOption,
                timeStep,
            },
        });
    }, [isTabIncomeVsExpense, dispatch, fallbackSelect, intervalIncVsExp, timeStepState]);
    const handleClearFilters = React.useCallback((e) => {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        dispatch({ type: 'update', payload: { filterObject: null, hasClearedFilters: true } });
        saveFilterDetailsToPreference(null);
    }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps
    const numFilterItems = (0, utils_1.countFilterItems)(filterObject) + ((filterObject === null || filterObject === void 0 ? void 0 : filterObject.get('payees').size) || 0);
    const filterIcon = React.useMemo(() => numFilterItems ? (<div className={classes.filterNumberIcon}>
      {(0, utils_1.countFilterItemsForDisplay)(filterObject) + filterObject.get('payees').size}
      <Close_1.default onClick={handleClearFilters} className={classes.filterClearButton}/>
    </div>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ) : <FilterList_1.default />, [filterObject, numFilterItems, classes.filterNumberIcon, classes.filterClearButton, handleClearFilters, isCategoriesLoading]);
    const openCustomDateRangeSelector = React.useCallback((anchor) => {
        setCustomDateRangeAnchor(anchor);
    }, []);
    const dateRangeOptions = React.useMemo(() => (0, state_1.getDateRangeOptions)(tabName).concat([{
            custom: true,
            onClick: openCustomDateRangeSelector,
            label: 'Custom',
            id: 'custom-date-range',
        }]), [tabName, openCustomDateRangeSelector]);
    const popoverPropsCustomDate = React.useMemo(() => ({
        transformOrigin: {
            horizontal: 'left',
            vertical: 'bottom',
        },
    }), []);
    const excludedFilterTabs = React.useMemo(() => tabName === 'savings' || tabName === 'net-worth' ? ['categories', 'tags', 'payees', 'advanced'] : null, [tabName]);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (format) => {
        setAnchorEl(null);
        if (Object.values(utils_2.downloadableFileTypes).includes(format)) {
            handleDownload(format);
        }
    };
    React.useEffect(() => () => {
        setIntervalIncVsExp(utils_2.IntervalFilterOptions[0].value);
    }, [tabName]);
    const initialInterval = React.useMemo(() => {
        const indexVal = utils_2.IntervalFilterOptions.findIndex((intervalItem) => intervalItem.value === timeStepState);
        return indexVal >= 0 ? utils_2.IntervalFilterOptions[indexVal] : utils_2.IntervalFilterOptions[0];
    }, [timeStepState]);
    return (<Paper_1.default className={classes.root} elevation={0}>
      <Box_1.default display="flex" flexWrap="wrap">
        {/* ====================== groupBy / Breakdown ====================== */}
        {breakdownOptionsProp && onBreakdownChange ? (<div className={classes.flexColumn}>
            <QTypography_1.default className={classes.reportsMenuLabel} variant="caption">Breakdown</QTypography_1.default>
            <ReportsMenu_1.default id="breakdown_button" initialValue={breakdownOptionsProp.find((option) => option.value === breakdownValue)} options={breakdownOptionsProp} onSelect={onBreakdownChange}/>
          </div>) : (<>
            {groupByOptions && (<div className={classes.flexColumn}>
                <QTypography_1.default className={classes.reportsMenuLabel} variant={'caption'}>Breakdown</QTypography_1.default>
                <ReportsMenu_1.default id="breakdown_button" disabled={(groupByOptions === null || groupByOptions === void 0 ? void 0 : groupByOptions.length) === 1} initialValue={(groupBy === null || groupBy === void 0 ? void 0 : groupBy.value) === 'total' ? { label: 'By none', value: 'none', id: 'breakdown_by_none' } : groupBy} options={groupByOptions} onSelect={handleGroupBySelect}/>
              </div>)}

            {/* ====================== Breakdown select, only for Income VS Expense Report ====================== */}
            {isTabIncomeVsExpense && (<div className={classes.flexColumn}>
                <QTypography_1.default className={classes.reportsMenuLabel} variant="caption">Breakdown</QTypography_1.default>
                <ReportsMenu_1.default id="income_expense_breakdown_select" initialValue={breakdownIncomeVsExpense} options={utils_2.IncomeVsExpenseBreakdownTypes} onSelect={handleIncomeVsExpenseBreakdownSelect}/>
              </div>)}
          </>)}

        {/* ====================== dateRange ====================== */}
        <div className={(0, classnames_1.default)(classes.flexColumn, classes.dateRangeContainer)}>
          <QTypography_1.default className={classes.reportsMenuLabel} variant={'caption'}>Date Range</QTypography_1.default>
          <ReportsMenu_1.default id="date_range_button" initialValue={dateRange} options={dateRangeOptions} onSelect={handleDateRangeSelect}/>
          <div style={{ display: customDateRangeAnchor ? 'block' : 'none' }}>  {/* maintains state/prev selection */}
            <QDateRangePicker_1.default anchorEl={customDateRangeAnchor} onSelect={handleCustomDateRangeSelect} onClose={handleCloseCustomDateRange} popoverProps={popoverPropsCustomDate} range id={'reports-pag-date-range-picker'}/>
          </div>
        </div>

        {/* ====================== Interval, only for Income VS Expense Report ====================== */}
        {isTabIncomeVsExpense && breakdownOtherThanNone && (<div className={(0, classnames_1.default)(classes.flexColumn, classes.dateRangeContainer)}>
            <QTypography_1.default className={classes.reportsMenuLabel} variant="caption">Interval</QTypography_1.default>
            <ReportsMenu_1.default id="income_expense_interval_select" initialValue={initialInterval} options={utils_2.IntervalFilterOptions} onSelect={handleIncomeVsExpenseIntervalSelect}/>
          </div>)}

        {/* ====================== View (Itemized Categories only) ====================== */}
        {showViewFilter && viewOptions && onViewChange && (<div className={(0, classnames_1.default)(classes.flexColumn, classes.dateRangeContainer)}>
            <QTypography_1.default className={classes.reportsMenuLabel} variant="caption">View</QTypography_1.default>
            <ReportsMenu_1.default id="itemized_view" initialValue={viewOptions.find((option) => option.value === viewValue)} options={viewOptions} onSelect={onViewChange}/>
          </div>)}

        {/* ====================== filters ====================== */}
        <div className={classes.filtersContainer}>
          <QButton_1.default startIcon={filterIcon} variant="outlinedBasic" onClick={toggleShowFilterSelect} onKeyDown={(e) => {
            if (e.key === 'Enter') {
                toggleShowFilterSelect(e);
            }
        }} className={(0, classnames_1.default)(classes.settingButton, classes.filterButton, filterObject && 'active')} id="filter_button">
            Filters
          </QButton_1.default>
          {filterAnchor &&
            <QFilterSelect_1.default onApply={handleApplyFilter} initialFilter={filterObject} popover openPopoverProps={{
                    transformOrigin: {
                        horizontal: 'left',
                        vertical: 'top',
                    },
                }} anchorEl={filterAnchor} onClose={toggleShowFilterSelect} excludedResourceTypes={excludedFilterTabs} resourceFilterFn={tabName === 'savings' ? filterOnlySavingsAccounts : undefined}/>}
        </div>
      </Box_1.default>
      <div className={(0, classnames_1.default)(classes.filtersContainer, classes.downloadButtonWrapper)}>
        {isTabIncomeVsExpense && breakdownOtherThanNone && (<IncomeExpenseReportToggle_1.default />)}
        {showDownloadButton && (<>
            <QTip_1.default title="Download Report" placement="left" distance={0} enterDelay={500}>
              <QButton_1.default variant="outlinedBasic" onClick={handleClick} className={classes.downloadButton}>
                <div>
                  <img src={download_svg_1.default} alt="download" className={classes.downloadIcon}/>
                  <ExpandMoreRounded_1.default />
                </div>
              </QButton_1.default>
            </QTip_1.default>
            <Menu_1.default id="basic-menu" anchorEl={anchorEl} open={open} onClose={handleClose} anchorOrigin={{ horizontal: -54, vertical: 'bottom' }}>
              {(0, utils_2.getDownloadFormats)().map((format) => (<MenuItem_1.default key={format.id} onClick={() => handleClose(format.value)}>
                  {format.label}
                </MenuItem_1.default>))}
            </Menu_1.default>
          </>)}
      </div>
    </Paper_1.default>);
};
exports.default = (0, compose_1.default)(react_1.withTheme)((0, mui_1.withStyles)(ChartSettings, chartSettings_styles_1.default));
